module.exports = __webpack_public_path__ + "media/images/favicon-60a2b1a0.png";